const scrollable = document.getElementById('scrollable');
const navbar = document.getElementById('navbar');
const sectionsTransparent = document.querySelectorAll('.navbar-transparent');
const contentHeroHomepage = document.getElementById('contentHeroHomepage');
const navPaths = navbar.querySelectorAll('path');
const navCircles = navbar.querySelectorAll('circle');
const logoWhite = document.getElementById('logoWhite');
const logoColor = document.getElementById('logoColor');
const menuBurger = document.getElementById('menuBurger');
const closeBurgerButtons = document.querySelectorAll('.closeBurgerButton');
const buttonMenuMobile = document.getElementById('buttonMenuMobile');
const closeSearch = document.getElementById('closeSearch');
const buttonCloseMenuMobile = document.getElementById('buttonCloseMenuMobile');
const searchButton = document.querySelectorAll('.searchButton');
const quickSearch = document.getElementById('quickSearch');
const cartButton = document.getElementById('cartButton');
let closeSidebarCart = document.getElementById('closeSidebarCart');
let sidebarCartInner = document.getElementById('sidebarCartInner');
const sidebarCart = document.getElementById('sidebarCart');
const menuItems = document.querySelectorAll('.topMenu');
const burgerMenuItems = document.querySelectorAll('.burgerMenuItems');
const headerSections = Array.from(document.querySelectorAll('.headerSection'));
const addToCartButton = document.getElementById('addToCart');
const menuAnnouncement = document.getElementById('menu-announcement');

// Accessibility variables
let cartAnnouncement = null;
let searchAnnouncement = null;
let previouslyFocusedElementCart = null;
let previouslyFocusedElementSearch = null;

const height = headerSections.reduce((acc, elem) => acc + elem.offsetHeight, 0);
const menuHeight = `${height + navbar.offsetHeight ?? 0}px`;

let touchEvent = 'touchstart' in window ? 'touchstart' : 'click';
let activeSubmenu = null;
let timeout;
let previouslyFocusedElement = null;
let isDesktopSubmenuOpen = false;
let currentDesktopTrigger = null;

function debounce(func, wait = 250) {
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Accessibility helper functions
function getFocusableElements(container) {
  const allFocusable = container.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );

  // Filter out elements that are not visible
  return Array.from(allFocusable).filter(element => {
    // Check if element or any parent has display: none or visibility: hidden
    const isVisible = element.offsetWidth > 0 &&
      element.offsetHeight > 0 &&
      getComputedStyle(element).visibility !== 'hidden' &&
      getComputedStyle(element).display !== 'none';

    // Check if element is disabled
    const isDisabled = element.disabled || element.getAttribute('aria-disabled') === 'true';

    return isVisible && !isDisabled;
  });
}

function trapFocus(e, container) {
  if (e.key !== 'Tab') return;

  const focusableElements = getFocusableElements(container);

  const firstFocusableElement = focusableElements[0];
  const lastFocusableElement = focusableElements[focusableElements.length - 1];

  if (focusableElements.length === 0) {
    e.preventDefault();
    return;
  }

  if (e.shiftKey) {
    if (document.activeElement === firstFocusableElement) {
      buttonCloseMenuMobile.focus()
      e.preventDefault();
    } else if (document.activeElement === buttonCloseMenuMobile) {
      lastFocusableElement.focus();
      e.preventDefault();
    }
  } else {
    if (document.activeElement === lastFocusableElement) {
      buttonCloseMenuMobile.focus()
      e.preventDefault();
    }else if (document.activeElement === buttonCloseMenuMobile) {
      firstFocusableElement.focus();
      e.preventDefault();
    }
  }
}

function handleDesktopSubmenuKeydown(e) {
  if (e.key === 'Escape') {
    closeDesktopSubmenu();
  } else if (e.key === 'Tab') {
    trapFocus(e, activeSubmenu);
  }
}

function handleMenuKeydown(e) {
  if (e.key === 'Escape') {
    // If we're in a submenu, go back to main menu
    if (activeSubmenu !== menuBurger) {
      backMenuBurger();
    } else {
      hideMenu();
    }
  } else if (e.key === 'Tab') {
    // Trap focus in whatever is the current active submenu
    if (activeSubmenu) {
      trapFocus(e, activeSubmenu);
    }
  }
}

// Search accessibility functions
function handleSearchKeydown(e) {
  if (e.key === 'Escape') {
    hideSearch();
  } else if (e.key === 'Tab') {
    trapFocus(e, quickSearch);
  }
}

// Cart accessibility functions
function handleCartKeydown(e) {
  if (e.key === 'Escape') {
    hideCart();
  } else if (e.key === 'Tab') {
    trapFocus(e, sidebarCartInner);
  }
}

function openDesktopSubmenu(submenu, triggerButton) {
  // Close any existing submenu first
  if (isDesktopSubmenuOpen && activeSubmenu) {
    closeDesktopSubmenu(false);
  }

  // Store references
  previouslyFocusedElement = triggerButton;
  currentDesktopTrigger = triggerButton;
  activeSubmenu = submenu;
  isDesktopSubmenuOpen = true;

  // Show submenu
  submenu.classList.remove('hidden');
  submenu.setAttribute('aria-hidden', 'false');

  // Update trigger button
  triggerButton.setAttribute('aria-expanded', 'true');

  // Announce to screen readers
  if (menuAnnouncement) {
    menuAnnouncement.textContent = `${triggerButton.textContent} submenu opened`;
  }

  // Add event listeners for accessibility
  document.addEventListener('keydown', handleDesktopSubmenuKeydown);

  // Focus management - move focus to first focusable element in submenu
  setTimeout(() => {
    const firstFocusable = getFocusableElements(submenu)[0];
    if (firstFocusable) {
      firstFocusable.focus();
    } else {
      // If no focusable elements, make submenu focusable
      submenu.setAttribute('tabindex', '-1');
      submenu.focus();
    }
  }, 100);

  setNavBarColor();
}

function closeDesktopSubmenu(returnFocus = true) {
  if (!isDesktopSubmenuOpen || !activeSubmenu) return;

  // Hide submenu
  activeSubmenu.classList.add('hidden');
  activeSubmenu.setAttribute('aria-hidden', 'true');

  // Update trigger button
  if (currentDesktopTrigger) {
    currentDesktopTrigger.setAttribute('aria-expanded', 'false');
  }

  // Announce to screen readers
  if (menuAnnouncement) {
    menuAnnouncement.textContent = 'Submenu closed';
  }

  // Return focus to trigger button
  if (returnFocus && previouslyFocusedElement) {
    previouslyFocusedElement.focus();
  }

  // Remove event listeners
  document.removeEventListener('keydown', handleDesktopSubmenuKeydown);

  // Reset state
  isDesktopSubmenuOpen = false;
  activeSubmenu = null;
  currentDesktopTrigger = null;
  previouslyFocusedElement = null;

  changeNavbarColor();
}

// Mobile menu functions
function showMenu() {
  // Store the currently focused element
  previouslyFocusedElement = document.activeElement;

  // Show/hide elements
  menuBurger.classList.remove('hidden');
  buttonMenuMobile.classList.add('hidden');
  buttonCloseMenuMobile.classList.remove('hidden');

  // Update ARIA attributes
  buttonMenuMobile.setAttribute('aria-expanded', 'true');
  buttonCloseMenuMobile.setAttribute('aria-expanded', 'true');
  menuBurger.setAttribute('aria-hidden', 'false');

  // Announce to screen readers
  if (menuAnnouncement) {
    menuAnnouncement.textContent = 'Navigation menu opened';
  }

  // Focus management - move focus to first menu item
  setTimeout(() => {
    const firstMenuItem = menuBurger.querySelector('.burgerMenuItems');
    if (firstMenuItem) {
      firstMenuItem.focus();
    }
  }, 100);

  // Add event listeners with proper context
  document.addEventListener('keydown', handleMenuKeydown);

  // Prevent body scroll
  document.body.style.overflow = 'hidden';

  setNavBarColor();
  activeSubmenu = menuBurger;
}

function hideMenu() {
  if (activeSubmenu != null) {
    // Hide/show elements
    activeSubmenu.classList.add('hidden');
    buttonMenuMobile.classList.remove('hidden');
    buttonCloseMenuMobile.classList.add('hidden');

    // Update ARIA attributes
    buttonMenuMobile.setAttribute('aria-expanded', 'false');
    buttonCloseMenuMobile.setAttribute('aria-expanded', 'false');
    menuBurger.setAttribute('aria-hidden', 'true');

    // Announce to screen readers
    if (menuAnnouncement) {
      menuAnnouncement.textContent = 'Navigation menu closed';
    }

    // Return focus to the button that opened the menu
    if (previouslyFocusedElement) {
      previouslyFocusedElement.focus();
    }

    // Remove event listeners
    document.removeEventListener('keydown', handleMenuKeydown);

    // Restore body scroll
    document.body.style.overflow = '';

    changeNavbarColor();
    activeSubmenu = null;
  }
}

function backMenuBurger() {
  if (activeSubmenu && activeSubmenu !== menuBurger) {
    activeSubmenu.classList.add('hidden');
    activeSubmenu.setAttribute('aria-hidden', 'true');
  }
  menuBurger.classList.remove('hidden');
  menuBurger.setAttribute('aria-hidden', 'false');
  activeSubmenu = menuBurger;

  // Focus on the first menu item when returning to main menu
  setTimeout(() => {
    const firstMenuItem = menuBurger.querySelector('.burgerMenuItems');
    if (firstMenuItem) {
      firstMenuItem.focus();
    }
  }, 100);
}

// Navigation color functions
function changeSvg(color) {
  navCircles.forEach((navCircle) => {
    if (navCircle.hasAttribute('fill')) {
      navCircle.setAttribute('fill', color);
    }
  });
  navPaths.forEach((navPath) => {
    if (navPath.hasAttribute('fill')) {
      navPath.setAttribute('fill', color);
    }
    if (navPath.hasAttribute('stroke')) {
      navPath.setAttribute('stroke', color);
    }
  });
}

function setNavBarTransparent() {
  navbar.classList.add('bg-transparent');
  navbar.classList.remove('bg-theme-offWhite');
  navbar.classList.add('text-theme-offWhite');
  logoWhite.classList.remove('!h-0');
  logoColor.classList.add('!h-0');
  changeSvg('#ECECE6');
}

function setNavBarColor() {
  navbar.classList.remove('bg-transparent');
  navbar.classList.add('bg-theme-offWhite');
  navbar.classList.remove('text-theme-offWhite');
  logoColor.classList.remove('!h-0');
  logoWhite.classList.add('!h-0');
  changeSvg('#3B1E1E');
}

let navIsTransparent = false;

function changeNavbarColor() {
  if (!contentHeroHomepage) return;

  const heroTop = contentHeroHomepage.getBoundingClientRect().top;
  const navHeight = navbar.offsetHeight;

  const enterTransparentThreshold = navHeight + 140;
  const exitTransparentThreshold = navHeight + 80;

  if (
    heroTop > enterTransparentThreshold &&
    !navIsTransparent &&
    !navbar.matches(':hover') &&
    !isDesktopSubmenuOpen &&
    activeSubmenu === null
  ) {
    setNavBarTransparent();
    navIsTransparent = true;
  } else if (
    heroTop <= exitTransparentThreshold &&
    navIsTransparent
  ) {
    setNavBarColor();
    navIsTransparent = false;
  }
}

// Initialize
changeNavbarColor();

scrollable.addEventListener('scroll', () => {
  changeNavbarColor();
});

let currentMouseY = 0;

// Track mouse position globally
document.addEventListener('mousemove', (e) => {
  currentMouseY = e.clientY;
});


let interval;

// Navbar hover effects
navbar.addEventListener('mouseenter', () => {
  setNavBarColor();
  clearInterval(interval)
});
navbar.addEventListener('mouseleave', () => {
  clearInterval(interval)
  interval = setInterval(() => {
    navbar.offsetHeight
    if (currentMouseY - navbar.getBoundingClientRect().bottom  > 50) {
      clearInterval(interval)
      changeNavbarColor();
    }
  }, 100);
});

// Search functionality with accessibility
function showSearch() {
  hideMenu();
  closeDesktopSubmenu();
  setNavBarColor();

  // Store previously focused element
  previouslyFocusedElementSearch = document.activeElement;

  // Show search overlay
  quickSearch.classList.remove('hidden');
  quickSearch.setAttribute('aria-hidden', 'false');

  // Create announcement element if it doesn't exist
  if (!searchAnnouncement) {
    searchAnnouncement = document.createElement('div');
    searchAnnouncement.setAttribute('aria-live', 'assertive');
    searchAnnouncement.setAttribute('aria-atomic', 'true');
    searchAnnouncement.className = 'visually-hidden';
    searchAnnouncement.id = 'search-announcement';
    document.body.appendChild(searchAnnouncement);
  }
  searchAnnouncement.textContent = 'Search overlay opened';

  // Add keyboard event listeners
  document.addEventListener('keydown', handleSearchKeydown);

  // Prevent body scroll
  document.body.style.overflow = 'hidden';

  // Focus on search input
  setTimeout(() => {
    const searchInput = document.getElementById('search');
    if (searchInput) {
      searchInput.focus();
    }
  }, 100);

  activeSubmenu = quickSearch;
}

function hideSearch() {
  quickSearch.classList.add('hidden');
  quickSearch.setAttribute('aria-hidden', 'true');

  // Announce to screen readers
  if (searchAnnouncement) {
    searchAnnouncement.textContent = 'Search overlay closed';
  }

  // Return focus to previously focused element
  if (previouslyFocusedElementSearch) {
    previouslyFocusedElementSearch.focus();
  }

  // Remove event listeners
  document.removeEventListener('keydown', handleSearchKeydown);

  // Restore body scroll
  document.body.style.overflow = '';

  activeSubmenu = null;
  changeNavbarColor();
}

if (!inSearch || inSearch !== true) {
  searchButton.forEach((item) => {
    item.addEventListener(touchEvent, (e) => {
      e.preventDefault();
      if (activeSubmenu !== quickSearch) {
        showSearch();
        return;
      }
      hideSearch();
    });

    // Add keyboard support for search buttons
    item.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (activeSubmenu !== quickSearch) {
          showSearch();
          return;
        }
        hideSearch();
      }
    });
  });

  if (closeSearch) {
    closeSearch.addEventListener(touchEvent, hideSearch);
    closeSearch.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        hideSearch();
      }
    });
  }
}

// Desktop menu event listeners with enhanced accessibility
menuItems.forEach((item) => {
  const submenuId = item.getAttribute('data-submenu');
  const submenu = document.getElementById(submenuId);

  if (!submenu) return;

  // Click handler
  item.addEventListener('click', (e) => {
    e.preventDefault();

    if (isDesktopSubmenuOpen && activeSubmenu === submenu) {
      closeDesktopSubmenu();
    } else {
      openDesktopSubmenu(submenu, item);
    }
  });

  // Enhanced keyboard navigation
  item.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      if (isDesktopSubmenuOpen && activeSubmenu === submenu) {
        closeDesktopSubmenu();
      } else {
        openDesktopSubmenu(submenu, item);
      }
    } else if (e.key === 'ArrowDown' && submenu) {
      e.preventDefault();
      openDesktopSubmenu(submenu, item);
    }
  });

  // Set up close button if it exists
  const closeButton = submenu.querySelector('.closeButton');
  if (closeButton) {
    closeButton.addEventListener('click', () => closeDesktopSubmenu());
    closeButton.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        closeDesktopSubmenu();
      }
    });
  }
});

// Click outside to close desktop submenu
document.addEventListener('click', (e) => {
  if (isDesktopSubmenuOpen && activeSubmenu) {
    const isClickInsideSubmenu = activeSubmenu.contains(e.target);
    const isClickOnTriggerButton = e.target.closest('.topMenu');

    if (!isClickInsideSubmenu && !isClickOnTriggerButton) {
      closeDesktopSubmenu();
    }
  }
});

// Focus out handler for desktop submenu
document.addEventListener('focusout', (e) => {
  if (isDesktopSubmenuOpen && activeSubmenu) {
    // Use setTimeout to allow focus to move to new element
    setTimeout(() => {
      const focusedElement = document.activeElement;
      const isInsideSubmenu = activeSubmenu.contains(focusedElement);
      const isOnTriggerButton = currentDesktopTrigger && currentDesktopTrigger.contains(focusedElement);

      if (!isInsideSubmenu && !isOnTriggerButton) {
        closeDesktopSubmenu(false);
      }
    }, 10);
  }
});

// Mobile menu button event listeners with keyboard support
buttonMenuMobile.addEventListener(touchEvent, showMenu);
buttonMenuMobile.addEventListener('keydown', (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    showMenu();
  }
});

buttonCloseMenuMobile.addEventListener(touchEvent, hideMenu);
buttonCloseMenuMobile.addEventListener('keydown', (e) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    hideMenu();
  }
});

// Close mobile menu when clicking outside
menuBurger.addEventListener('click', (e) => {
  if (e.target === menuBurger) {
    hideMenu();
  }
});

menuBurger.style.paddingTop = menuHeight;

closeBurgerButtons.forEach((item) => {
  item.addEventListener(touchEvent, backMenuBurger);
  item.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      backMenuBurger();
    }
  });
});

// Mobile burger menu items
burgerMenuItems.forEach((item) => {
  const submenuId = item.getAttribute('data-submenu');
  const submenu = document.getElementById(submenuId);

  item.addEventListener(touchEvent, () => {
    // Hide current submenu if it's different
    if (activeSubmenu && activeSubmenu !== submenu) {
      activeSubmenu.classList.add('hidden');
      activeSubmenu.setAttribute('aria-hidden', 'true');
    }

    // Close all details elements in the submenu
    submenu.querySelectorAll('details').forEach((details) => (details.open = false));

    // Show the new submenu
    submenu.classList.remove('hidden');
    submenu.setAttribute('aria-hidden', 'false');
    item.setAttribute('aria-expanded', 'true');

    // Update active submenu reference
    activeSubmenu = submenu;

    submenu.style.height = '100vh';
    submenu.style.paddingTop = menuHeight;

    // Focus management for burger submenu - use the improved getFocusableElements
    setTimeout(() => {
      const firstFocusableInSubmenu = getFocusableElements(submenu)[0];
      if (firstFocusableInSubmenu) {
        firstFocusableInSubmenu.focus();
      }
    }, 100);
  });

  // Add keyboard support for burger menu items
  item.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      item.click();
    }
  });
});

// Cart functionality with accessibility improvements
async function showCart(e) {
  if (activeSubmenu === sidebarCart) {
    return;
  }
  if (e) {
    e.preventDefault();
  }

  // Store previously focused element
  previouslyFocusedElementCart = document.activeElement;

  hideMenu();
  closeDesktopSubmenu();
  setNavBarColor();

  // Show cart
  sidebarCart.classList.remove('translate-x-full');
  sidebarCart.setAttribute('aria-hidden', 'false');
  sidebarCartInner.classList.add('!translate-x-0');
  activeSubmenu = sidebarCart;

  // Create announcement element if it doesn't exist
  if (!cartAnnouncement) {
    cartAnnouncement = document.createElement('div');
    cartAnnouncement.setAttribute('aria-live', 'assertive');
    cartAnnouncement.setAttribute('aria-atomic', 'true');
    cartAnnouncement.className = 'visually-hidden';
    cartAnnouncement.id = 'cart-announcement';
    document.body.appendChild(cartAnnouncement);
  }
  cartAnnouncement.textContent = 'Shopping cart opened';

  // Add keyboard event listeners
  document.addEventListener('keydown', handleCartKeydown);

  // Prevent body scroll
  document.body.style.overflow = 'hidden';

  // Focus management - move to first focusable element in cart
  setTimeout(() => {
    const firstFocusable = getFocusableElements(sidebarCartInner)[0];
    if (firstFocusable) {
      firstFocusable.focus();
    } else {
      // If no focusable elements, make cart focusable
      sidebarCartInner.setAttribute('tabindex', '-1');
      sidebarCartInner.focus();
    }
  }, 100);
}

function hideCart() {
  if (activeSubmenu !== sidebarCart) return;

  sidebarCart.classList.add('translate-x-full');
  sidebarCart.setAttribute('aria-hidden', 'true');
  sidebarCartInner.classList.remove('!translate-x-0');

  // Announce to screen readers
  if (cartAnnouncement) {
    cartAnnouncement.textContent = 'Shopping cart closed';
  }

  // Return focus to trigger element
  if (previouslyFocusedElementCart) {
    previouslyFocusedElementCart.focus();
  }

  // Remove event listeners
  document.removeEventListener('keydown', handleCartKeydown);

  // Restore body scroll
  document.body.style.overflow = '';

  activeSubmenu = null;
  changeNavbarColor();
}

async function removeFromCart(event, button) {
  event.preventDefault();
  const itemKey = button.closest('.itemLine').dataset.key;
  const productTitle = button.closest('.itemLine').querySelector('h3 a').textContent;

  debouncedUpdateCart({ [itemKey]: 0 });

  // Announce removal to screen readers
  if (cartAnnouncement) {
    cartAnnouncement.textContent = `${productTitle} removed from cart`;
  }
}

async function updateCart(updates = {}) {
  const values = {
    ...{
      sections: 'sidebar-cart',
      sections_url: '/cart'
    },
    updates
  };

  const cartFetch = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(values)
    }
  );
  const data = await cartFetch.json();
  sidebarCartInner.innerHTML = data.sections['sidebar-cart'];
  sidebarCart.querySelector('form').classList.remove('hidden');
  closeSidebarCart = document.getElementById('closeSidebarCart');

  // Re-attach event listeners with accessibility support
  if (cartButton) {
    cartButton.addEventListener(touchEvent, showCart);
    cartButton.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        showCart();
      }
    });
  }

  closeSidebarCart.addEventListener(touchEvent, hideCart);
  closeSidebarCart.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      hideCart();
    }
  });

  const removeButtons = document.querySelectorAll('.removeProduct');
  removeButtons.forEach((button) => {
    button.addEventListener('click', (e => removeFromCart(e, button)));
    button.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        removeFromCart(e, button);
      }
    });
  });

  let recos = [];
  data.items.forEach((item) => {
    recos.push(getCartReco(item.product_id));
  });
  const res = await Promise.allSettled(recos);
  const result = res.flatMap((line) => (line.status === 'fulfilled' ? line.value.products : []));
  setupRecos(result);

  setupQuantityButtons();
}

function setupRecos(products) {
  if (products.length === 0) {
    const recoSidebarCart = document.getElementById('recoSidebarCart');
    if (recoSidebarCart) {
      recoSidebarCart.style.display = 'none';
    }
    return;
  }
  const recoSidebarCart = document.getElementById('recoSidebarCart');
  if (recoSidebarCart) {
    recoSidebarCart.style.display = 'block';
  }
  const recoContainer = document.getElementById('recoSidebarCart');
  recoContainer.innerHTML = '';
  const template = document.getElementById('tplReco');

  products.forEach(product => {
    const recoVariant = product.variants.find(el => el.available === true);
    if (!recoVariant) {
      return;
    }
    const reco = template.content.cloneNode(true);

    const imgElement = reco.querySelector('.recoImg');
    imgElement.src = product.featured_image;
    imgElement.alt = product.title;

    reco.querySelector('.recoTitle').textContent = product.title;
    reco.querySelector('.recoTitle').href = product.url;

    const priceElement = reco.querySelector('.recoPrice');
    priceElement.textContent = formatMoneyCart(product.price);
    if (recoVariant.options.length > 0 && recoVariant.options[0] !== 'Default Title') {
      reco.querySelector('.recoOption').textContent = recoVariant.options[0];
    }

    const addButton = reco.querySelector('.recoBtn');
    addButton.addEventListener('click', () => {
      addToCart({
        id: recoVariant.id,
        quantity: 1
      });
    });

    // Add keyboard support for recommendation buttons
    addButton.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        addToCart({
          id: recoVariant.id,
          quantity: 1
        });
      }
    });

    recoContainer.appendChild(reco);
  });
}

let updatesDebounced = {};
let debouncedFunc = null;

function debouncedUpdateCart(options) {
  updatesDebounced = { ...updatesDebounced, ...options };
  debouncedFunc = debounce(function() {
    updateCart(updatesDebounced);
    updatesDebounced = {};
  }, 1000);
  debouncedFunc();
}

// Helper function to update quantity button states
function updateQuantityButtonStates(container, currentValue) {
  const input = container.querySelector('input[type="number"]');
  console.log(container)
  const increaseBtn = container.querySelector('.increase-quantity-btn');
  const decreaseBtn = container.querySelector('.decrease-quantity-btn');
  const min = parseInt(input.min, 10) || 1;
  const max = parseInt(input.max, 10) || 99999;

  // Update decrease button
  if (currentValue <= min) {
    decreaseBtn.disabled = true;
    decreaseBtn.setAttribute('aria-disabled', 'true');
  } else {
    decreaseBtn.disabled = false;
    decreaseBtn.setAttribute('aria-disabled', 'false');
  }

  // Update increase button
  if (currentValue >= max) {
    increaseBtn.disabled = true;
    increaseBtn.setAttribute('aria-disabled', 'true');
  } else {
    increaseBtn.disabled = false;
    increaseBtn.setAttribute('aria-disabled', 'false');
  }
}

function setupQuantityButtons() {
  document.querySelectorAll('#cart_form .increase-quantity-btn').forEach(button => {
    button.addEventListener('click', () => {
      const container = button.closest('#qtyContainer');
      const input = container.querySelector('input[type="number"]');
      const itemKey = button.closest('.itemLine').dataset.key;
      const currentValue = parseInt(input.value, 10);
      const max = parseInt(input.max, 10) || 99999;

      if (currentValue < max) {
        const newValue = currentValue + 1;
        input.value = newValue;
        debouncedUpdateCart({ [itemKey]: newValue });

        // Update button states
        updateQuantityButtonStates(container, newValue);
      }
    });

    // Add keyboard support
    button.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        button.click();
      }
    });
  });

  document.querySelectorAll('#cart_form .decrease-quantity-btn').forEach(button => {
    button.addEventListener('click', () => {
      const container = button.closest('#qtyContainer');
      const input = container.querySelector('input[type="number"]');
      const itemKey = button.closest('.itemLine').dataset.key;
      const currentValue = parseInt(input.value, 10);
      const min = parseInt(input.min, 10) || 1;

      if (currentValue > min) {
        const newValue = currentValue - 1;
        input.value = newValue;
        debouncedUpdateCart({ [itemKey]: newValue });

        // Update button states
        updateQuantityButtonStates(container, newValue);
      }
    });

    // Add keyboard support
    button.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        button.click();
      }
    });
  });

  document.querySelectorAll('#cart_form #qtyContainer input[type="number"]').forEach(input => {
    input.addEventListener('change', () => {
      const itemKey = input.closest('.itemLine').dataset.key;
      const newValue = parseInt(input.value, 10);
      const container = input.closest('#qtyContainer');

      const min = parseInt(input.min, 10) || 1;
      if (newValue < min) {
        input.value = min;
        debouncedUpdateCart({ [itemKey]: min });
        updateQuantityButtonStates(container, min);
        return;
      }

      const max = parseInt(input.max, 10) || 99999;
      if (newValue > max) {
        input.value = max;
        debouncedUpdateCart({ [itemKey]: max });
        updateQuantityButtonStates(container, max);
        return;
      }

      debouncedUpdateCart({ [itemKey]: newValue });
      updateQuantityButtonStates(container, newValue);
    });
  });

  // Initialize button states
  document.querySelectorAll('#cart_form #qtyContainer').forEach(container => {
    const input = container.querySelector('input[type="number"]');
    const currentValue = parseInt(input.value, 10);
    updateQuantityButtonStates(container, currentValue);
  });
}

async function addToCart(data) {
  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      ...data
    })
  });

  updateCart().then(showCart);
}

async function getCartReco(id) {
  let res = [];
  try {
    const fetched = await fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${id}&limit=10&intent=complementary`);
    res = await fetched.json();
  } catch (e) {
  }
  return res;
}

if (addToCartButton) {
  addToCartButton.addEventListener('click', function(e) {
    e.preventDefault();

    const form = addToCartButton.closest('form');
    if (!form) return;

    const formData = new FormData(form);
    const formEntries = Object.fromEntries(formData.entries());

    const variantId = formEntries.id || formEntries['variant-id'] || formEntries.variant;
    const quantity = parseInt(formEntries.quantity || 1, 10);

    addToCart({
      id: variantId,
      quantity: quantity,
      properties: {}
    });
  });

  // Add keyboard support for add to cart button
  addToCartButton.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      addToCartButton.click();
    }
  });
}

// Initial cart setup
if (!inCart || inCart !== true) {
  updateCart();
}

// Enhanced click outside to close cart
sidebarCart.addEventListener('click', (e) => {
  if (!sidebarCartInner.contains(e.target)) {
    hideCart();
  }
});

// Enhanced focus management for cart
document.addEventListener('focusout', (e) => {
  if (activeSubmenu === sidebarCart && sidebarCartInner) {
    setTimeout(() => {
      const focusedElement = document.activeElement;
      const isInsideCart = sidebarCartInner.contains(focusedElement);

      if (!isInsideCart) {
        // Only close if focus moved completely outside the cart
        if (!sidebarCart.contains(focusedElement)) {
        //  hideCart();
        }
      }
    }, 10);
  }
});

function formatMoneyCart(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*}}/;
  const formatString = format || '{{amount_with_comma_separator}}€';

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  const match = formatString.match(placeholderRegex);

  if (match) {
    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  }

  return formatString.replace(placeholderRegex, value);
}

window.addEventListener('resize', () => {
  if ( activeSubmenu === menuBurger && window.innerWidth >= 1024) {
    hideMenu();
  }
});
